import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TranslatedCopy } from '../../../../intl/TranslatedCopy';
import { H1, Currency } from '../../../../components';

const OrderReturnsPageSelectHeader = ({ returnQuantity, returnAmount, currencyCode }) => (
  <div
    className={classnames(
      'orderReturns__section_page_header',
      'prl7-sm prl10-md pt6-sm pb5-sm flex-container start bg-white align-center'
    )}
  >
    <div className='u-full-width mr7-lg mb5-sm mb0-lg'>
      <H1>
        <TranslatedCopy id='orderreturns.selectProducts.copy' />
      </H1>
      <p>
        <TranslatedCopy id='global.totalQuantity' />
        {': '}
        {returnQuantity}
        {' | '}
        <TranslatedCopy id='orderreturns.returnAmount' />
        {': '}
        <Currency value={returnAmount || '0'} type={currencyCode} />
      </p>
    </div>
    <p className='body-4 text-color-warm-grey'>
      <TranslatedCopy id='orderreturns.selectProducts.instructions' />
    </p>
  </div>
);

OrderReturnsPageSelectHeader.propTypes = {
  returnQuantity: PropTypes.number,
  returnAmount: PropTypes.number,
  currencyCode: PropTypes.string
};

OrderReturnsPageSelectHeader.defaultProps = {
  returnQuantity: 0,
  returnAmount: 0,
  currencyCode: null
};

export default OrderReturnsPageSelectHeader;
